export default __webpack_public_path__ + "static/media/Icon_MultipleSelectTextChoice.43ea4ea2.svg";